'use strict';
invoicesDueController.$inject = [
	'$scope',
	'$q',
	'$interval',
	'dialogHelper',
	'reportHelper',
	'authService',
	'vendorService',
	'userService',
	'USER_CLAIMS',
	'BUSY_MESSAGE',
];
angular.module('schoolLinqApp').controller('invoicesDueController', invoicesDueController);

function invoicesDueController(
	$scope,
	$q,
	$interval,
	dialogHelper,
	reportHelper,
	authService,
	vendorService,
	userService,
	USER_CLAIMS,
	BUSY_MESSAGE
) {
	var viewModel = getViewModel($scope.mode || 'fund');
	$scope.vm = viewModel;

	$scope.$watch(
		'vm.report.fromDT',
		function (changed, old) {
			//Ensure endDT is equal or greater to startDT each time startDT changes.
			if (!_.isUndefined(changed) && changed !== null) {
				if (_.isUndefined($scope.vm.report.toDT) || $scope.vm.report.toDT === null) {
					$scope.vm.report.toDT = changed;
					return;
				}

				if (moment(changed).startOf('day') > moment($scope.vm.report.toDT).startOf('day')) {
					$scope.vm.report.toDT = changed;
					return;
				}
			}
		},
		true
	);

	$scope.reportInterval = null;
	$scope.isReportFinished = false;

	$scope.loadingPromise = $q.all([$scope.vm.loadVendors($scope.vm), $scope.vm.loadUsers($scope.vm)]);

	function getViewModel(moduleName) {
		var model = {
			module: moduleName,
			message: BUSY_MESSAGE.Loading,
			report: {
				reportType: 'Vendor',
				fromDT: moment().toDate(),
				toDT: moment().toDate(),
				vendorId: null,
				userId: null,
				includeEmployeeReimbursements: false,
				employeeReimbursementsOnly: false,
			},
			vendors: [],
			users: [],
			validationErrors: [],
			accessPayroll: false,
			errors: null,
			isSaMode: moduleName === 'sa',
		};

		function validateReportParams(model) {
			model.validationErrors = [];
			let isValid = true;

			if (!model.report.fromDT) {
				model.validationErrors.push("Please select a 'From' date.");
				isValid = false;
			}

			if (!model.report.toDT) {
				model.validationErrors.push("Please select a 'To' date.");
				isValid = false;
			}

			if (isValid === true && moment(model.report.fromDT).startOf('day') > moment(model.report.toDT).startOf('day')) {
				model.validationErrors.push('Date Range is invalid!');
				isValid = false;
			}

			return isValid;
		}

		function openReport(model) {
			$scope.reportForm.$setSubmitted();
			if (!$scope.reportForm.$valid) return false;

			if (!validateReportParams(model)) {
				dialogHelper.openMessageBox('Invoice Due Report Error!', null, model.validationErrors, 'Warning');
				return false;
			}

			$scope.isReportFinished = false;
			model.message = BUSY_MESSAGE.GeneratingReport;
			$scope.loadingPromise = $scope.reportInterval = $interval(function () {
				if ($scope.isReportFinished) {
					$interval.cancel($scope.reportInterval);
					$scope.isReportFinished = false;
				}
			}, 1000);

			var report = {
				ReportType: model.report.reportType,
				FromDT: model.report.fromDT,
				ToDT: model.report.toDT,
				Id: model.report.vendorId,
				UserId: model.report.userId,
				IncludePayrollInvoices: model.report.includePayrollInvoices,
				IncludeEmployeeReimbursements: model.report.includeEmployeeReimbursements,
				EmployeeReimbursementsOnly: model.report.employeeReimbursementsOnly,
			};

			reportHelper.getReport($scope, '/api/fundreports/invoicesduereport', report, 'InvoicesDueReport.pdf');
		}

		function exportExcel(model) {
			$scope.reportForm.$setSubmitted();
			if (!$scope.reportForm.$valid) return false;

			if (!validateReportParams(model)) return false;

			$scope.isReportFinished = false;
			model.message = BUSY_MESSAGE.GeneratingExcelFile;
			$scope.loadingPromise = $scope.reportInterval = $interval(function () {
				if ($scope.isReportFinished) {
					$interval.cancel($scope.reportInterval);
					$scope.isReportFinished = false;
				}
			}, 1000);

			var report = {
				ReportType: model.report.reportType,
				FromDT: model.report.fromDT,
				ToDT: model.report.toDT,
				Id: model.report.vendorId,
				UserId: model.report.userId,
				IncludePayrollInvoices: model.report.includePayrollInvoices,
				IncludeEmployeeReimbursements: model.report.includeEmployeeReimbursements,
				EmployeeReimbursementsOnly: model.report.employeeReimbursementsOnly,
			};

			reportHelper.getExcel($scope, '/api/fundreports/invoicesdueexcel', report, 'InvoicesDue.xlsx');
		}

		function loadVendors(model) {
			$scope.loadingPromiseVendor = vendorService
				.getInvoicedVendorsAndOrEmployees(model.report.includeEmployeeReimbursements, model.report.employeeReimbursementsOnly)
				.then(_.partial(finishLoadingVendors, model));

			//return vendorService.getVendors().then(_.partial(finishLoadingVendors, model));

			function finishLoadingVendors(model, response) {
				model.vendors = response.data.vendors;
				model.vendors.unshift({ Id: null, Name: 'All' });
				return angular.noop;
			}
		}

		function userSort(a, b) {
			if (a.FullName === null && b.FullName !== null) {
				return -1;
			}
			if (a.FullName !== null && b.FullName === null) {
				return 1;
			}
			if ((a.FullName === null && b.FullName === null) || a.FullName.toLowerCase() === b.FullName.toLowerCase()) {
				return a.UserName.toLowerCase() > b.UserName.toLowerCase() ? 1 : a.UserName.toLowerCase() < b.UserName.toLowerCase() ? -1 : 0;
			}
			return a.FullName.toLowerCase() > b.FullName.toLowerCase() ? 1 : -1;
		}

		function loadUsers(model) {
			$scope.loadingPromiseUser = userService.list().then(_.partial(finishLoadingUsers, model));

			function finishLoadingUsers(model, response) {
				model.users = response.data.users
					.filter((f) => f.FullName || f.UserName)
					.sort(userSort)
					.map((u) => ({
						id: u.Id,
						name: (u.FullName ? u.FullName : '') + (u.UserName ? ` - ${u.UserName}` : ''),
					}));
				model.users.unshift({ id: null, name: 'All Users' });
				return angular.noop;
			}
		}

		return angular.extend(model, {
			loadVendors: _.partial(loadVendors, model),
			loadUsers: _.partial(loadUsers, model),
			openReport: _.partial(openReport, model),
			exportExcel: _.partial(exportExcel, model),
		});
	}
}
